import { useMutation }              from '@tanstack/react-query';
import RestClient                   from "app/client/rest";
import { useDispatch }              from "react-redux";
import providerSlice         	    from '../../store/reducers/provider';
import { useNavigate }              from 'react-router-dom';

export const useGetAccessToken = () => {
    const dispatch  = useDispatch();

    return useMutation({
        mutationKey: ['accessToken'],
        mutationFn: async data => {
            const res = await RestClient.fetch({
                url: `v1/Auth/AccessToken`,
                type: 'AUTH',
                method: 'POST',
                data: data
            })

            dispatch(providerSlice.actions.setAccessToken(res.accessToken));
            dispatch(providerSlice.actions.setCustomer(res.userInfo));
            dispatch(providerSlice.actions.setQueryData(data.customerIdentity));


            return res
        },
        onError: err => {
            console.log(err)
        },
    });
};

export const useInvoiceQuery = () => {
    const navigate  = useNavigate();
    const dispatch  = useDispatch();

    return useMutation({
        mutationKey: ['invoiceQuery'],
        mutationFn: async payload => {

            const res = await RestClient.fetch({
                url: `v1/Document/GetDocument`,
                method: 'POST',
                data: payload.data,
                accessToken: payload.accessToken
            })

            if (res.earchiveInvoice.payableAmount === Number(payload?.amount || 0)) {
                dispatch(providerSlice.actions.setInvoiceData(res));
                navigate('/invoice-details');
            } else {
                dispatch(providerSlice.actions.setInvoiceData(null));
                payload.callback();
            }
            
            return res;
        },
        onError: err => {
            dispatch(providerSlice.actions.setInvoiceData(null));
        },
    });
};

export const useSendInvoiceEmail = () => {
    return useMutation({
        mutationKey: ['sendEmailHandler'],
        mutationFn: async payload => {

            const res = await RestClient.fetch({
                url         : `v1/Document/SendMail`,
                method      : 'POST',
                data        : payload.data,
                accessToken : payload.accessToken
            })
            
            return res;
        },
        onError: err => {
            console.log(err)
        },
    });
};

export const useDownloadFile = () => {
    return useMutation({
        mutationKey: ['downloadFileHandler'],
        mutationFn: async payload => {

            const res = await RestClient.fetch({
                url: `v1/Document/GetDocument`,
                method: 'POST',
                data: payload.data,
                accessToken: payload.accessToken
            })

            let url;
            if (payload.data.outputType === 'pdf')
                url ="data:application/pdf;base64," + res.data;

            if (payload.data.outputType === 'html')
                url ="data:application/txt;base64," + res.data;
            
            if (payload.data.outputType === 'ubl')
                url ="data:application/xml;base64," + res.data;

            
            let link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${res.earchiveInvoice.documentId}-${payload.data.outputType}.${payload.data.outputType === 'ubl' ? 'xml' :payload.data.outputType}`);

            document.body.appendChild(link);

            link.click();

            URL.revokeObjectURL(url);

            link.remove();
        
            return res;
        },
        onError: err => {
            console.log(err)
        },
    });
};
